import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 1.06189C7.05369 1.55399 4 4.92038 4 9H11V1.06189Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 1.06189V9H20C20 4.92038 16.9463 1.55399 13 1.06189Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20 11H4V15C4 19.4183 7.58172 23 12 23C16.4183 23 20 19.4183 20 15V11Z"}}]};

const MouseFilled = Vue.extend<IconProps>({
  name: 'MouseFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'mouse-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default MouseFilled;
